import { render } from "./PermissionList.vue?vue&type=template&id=06b4cca2"
import script from "./PermissionList.vue?vue&type=script&lang=js"
export * from "./PermissionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__